<template>
    <v-dialog v-model="isDialogOpen" persistent max-width="350">
        <v-card>
            <v-card-text>
                <h1 class="title-dialog-two-options">
                    Editar Nota
                </h1>
                <v-textarea style="margin-top: 30px;" v-model="newNote" label="Nota" density="compact"
                    variant="underlined" class="no-bg" rows="3" />
            </v-card-text>
            <v-card-actions style="display: flex; flex-direction: column;">
                <v-btn
                    class="btn-action-save-note"
                    rounded="xl"
                    color="#FFFFFF"
                    :loading="isSavingData"
                    @click="okBtn">
                    Guardar
                </v-btn>
                <v-btn class="btn-dialog-two-options" color="#707070" @click="isDialogOpen = false">
                    Cerrar sin cambios
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import stockApi from '@/api/stockApi'
export default {
  name: 'CommerciaVueDialogEditNote',
  emits: ['saveOK'],
  data () {
    return {
      isDialogOpen: false,
      isSavingData: false,
      newNote: '',
      id: ''
    }
  },
  methods: {
    open (id, note) {
      this.id = id
      this.newNote = note
      this.isDialogOpen = true
    },
    async okBtn () {
      this.isSavingData = true
      const dataSave = await stockApi.editNote(this.id, this.newNote)
      if (dataSave) {
        this.$emit('saveOK')
        this.isDialogOpen = false
      }
      this.isSavingData = false
    }
  }
}
</script>

<style scoped>
.btn-action-save-note{
    background-color: #FF5700;
    width: 150px;
    margin-bottom: 20px;
}
</style>
